export default __webpack_public_path__ + "static/media/skirmishers_war_maul.b97cb418.jpg";